const defaultTheme = require('tailwindcss/defaultTheme');
const plugin = require('tailwindcss/plugin');

module.exports = {
  mode: 'jit',
  purge: [
    './public/**/*.html',
    './src/**/*.{js,jsx,ts,tsx,vue}',
    './src/**/**/*.{js,jsx,ts,tsx,vue}',
  ],
  darkMode: false, // or 'media' or 'class'
  variants: {
    extend: {},
  },
  plugins: [
    require('@tailwindcss/line-clamp'),
    plugin(({ addComponents }) => {
      addComponents({
        '.default-border': {
          'box-shadow': '0px 0px 4px #DCE1F5',
        },
      });
    }),

  ],
  theme: {
    extend: {
      animation: {
        'fade-in': 'fade-in 0.5s ease-out',
        'fade-out': 'fade-out 0.5s ease-out',
      },
      borderWidth: {
        6: '6px',
      },
      boxShadow: {
        ...defaultTheme.boxShadow,
        input: '0px 4px 4px 0px #DCE1F566',
      },
      colors: {
        black: '#0D1017',
        blue: {
          50: '#F4F6FF',
          100: '#DCE1F5',
          200: '#BECBF4',
          300: '#87A1EC',
          400: '#2097F6',
          500: '#4169E1',
          700: '#1B3FAB',
        },
        'blue-green': {
          500: '#16A683',
        },
        brown: {
          500: '#A65B16',
        },
        current: 'currentColor',
        gray: {
          50: '#CBD4DB',
          300: '#9AA4B2',
          500: '#6F7782',
          700: '#4E5668',
        },
        'grass-green': {
          500: '#23A840',
        },
        'light-gray': {
          100: '#FAFBFF',
          400: '#FAFAFA',
          500: '#F1F1F1',
        },
        primary: {
          50: '#F4F6FF',
          100: '#DCE1F5',
          200: '#BECBF4',
          300: '#87A1EC',
          400: '#2097F6',
          500: '#4169E1',
          700: '#1B3FAB',
        },
        pink: {
          50: '#FFF3F9',
          500: '#DA0875',
        },
        red: {
          500: '#EE4261',
        },
        secondary: {
          50: '#CBD4DB',
          300: '#9AA4B2',
          500: '#6F7782',
        },
        'seaweed-green': {
          50: '#FAFDFF',
          100: '#70C0D4',
          500: '#197F99',
        },
        transparent: 'transparent',
        white: '#FFFFFF',
        yellow: {
          500: '#F2C94C',
        },
      },
      fontSize: {
        '3.25xl': ['2rem', '46px'],
        '3.5xl': ['2.125rem', '51px'],
        '4.5xl': ['2.375rem', '57px'],
        ...defaultTheme.fontSize,
      },
      inset: {
        25.5: '6.375rem',
        ...defaultTheme.inset,
      },
      keyframes: {
        'fade-in': {
          from: {
            opacity: 0,
          },
          to: {
            opacity: 1,
          },
        },
        'fade-out': {
          from: {
            opacity: 1,
          },
          to: {
            opacity: 0,
          },
        },
      },
      margin: {
        13: '3.25rem',
        25: '6.25rem',
      },
      maxHeight: {
        '1/2': '50%',
        'modal-content': '12.375rem',
        ...defaultTheme.maxHeight,
      },
      minHeight: {
        '1/3': '33.33%',
        '1/5': '20%',
        'menu-list-desktop': '152px',
        'menu-list-mobile': '140px',
        'modal-content': '4rem',
        ...defaultTheme.minHeight,
      },
      maxWidth: {
        '1/2': '50%',
        21.25: '85%',
        ...defaultTheme.maxWidth,
      },
      minWidth: {
        '1/2': '50%',
        ...defaultTheme.minWidth,
      },
      padding: {
        25: '6.25rem',
      },
      spacing: {
        'cart-sidebar': '448px',
        'menu-sidebar': '285px',
        ...defaultTheme.spacing,
      },
      width: {
        70: '17.5rem',
        100: '25rem',
        'modal-lg': '650px',
        ...defaultTheme.width,
      },
    },
    screens: {
      ...defaultTheme.screens,
      xs: {
        min: '200px',
        max: '319px',
      },
      sm: {
        min: '320px',
        max: '767px',
      },
      md: {
        min: '768px',
        max: '1099px',
      },
    },
  },
};
